import React, { useState, useCallback } from 'react';
import { TSync } from '../SyncView/SyncView';
import Video from '../Video/Video';
import styled from 'styled-components';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
type Props = {
  apikey: string;
  video: TSync;
  i: number;
  baseUrl?: string;
  locked: boolean;
  onToggleLock: (index: number) => void;
  frame: number;
  setFrame: (index: number, frame: number) => void;
  interactive: boolean;
  framerate?: number;
};

const useStyles = makeStyles({
  root: {
    color: '#00a06a !important',
  },
  selected: {
    backgroundColor: 'rgba(217, 217, 217, 0.46) !important',
  },
});

const AnnotatedVideo: React.FunctionComponent<Props> = (props) => {
  const [size, setSize] = useState('320');
  const classes = useStyles();

  const handleSize = (_event: any, value: string) => {
    if (value) setSize(value);
  };

  const onToggleLock = useCallback(() => {
    props.onToggleLock(props.i);
  }, [props]);

  return (
    <Parent key={props.i}>
      <MetaDataContainer>
        {props.video.name}: {props.frame} {props.locked ? ' - locked' : ''}
      </MetaDataContainer>

      <Video
        framerate={props.framerate}
        key={props.i}
        index={props.i}
        video={props.video.url}
        size={parseInt(size)}
        apikey={props.apikey}
        interactive={props.interactive}
        setFrame={props.setFrame}
        baseUrl={props.baseUrl}
        frame={props.frame}
      />
      {props.interactive && (
        <ButtonContainer>
          <ToggleButtonGroup value={size} exclusive onChange={handleSize} aria-label="Image quality">
            <ToggleButton
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              value="320"
              aria-label="low quality">
              LQ
            </ToggleButton>
            <ToggleButton
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              value="640"
              aria-label="medium quality">
              MQ
            </ToggleButton>
            <ToggleButton
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              value="1280"
              aria-label="high quality">
              HQ
            </ToggleButton>
            <ToggleButton
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              value="2560"
              aria-label="ultra quality">
              UHQ
            </ToggleButton>
          </ToggleButtonGroup>
          <Tooltip title={props.locked ? 'Unlock the video' : 'Lock the video'} aria-label="lock">
            <IconButton color="primary" aria-label="lock" onClick={onToggleLock}>
              {props.locked ? <LockIcon /> : <LockOpenIcon />}
            </IconButton>
          </Tooltip>
        </ButtonContainer>
      )}
    </Parent>
  );
};

const MetaDataContainer = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  color: white;
  background-color: black;
  opacity: 0.5;
  z-index: 1;
`;

const ButtonContainer = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  color: white;
  background-color: black;
  opacity: 0.7;
  z-index: 1;
`;

const Parent = styled.div`
  height: 100%;
  position: relative;
`;

(AnnotatedVideo as any).whyDidYouRender = true;

export default AnnotatedVideo;
